import type { AdminJwtUser } from '@/constants/adminRole'
import { AdminRole } from '@/constants/adminRole'
import type { NavLinks } from '@/@diffrag/sidebar/type'

export function filterNavsByRole(
  navs: NavLinks[],
  user?: AdminJwtUser,
): NavLinks[] {
  const role = user?.role ?? AdminRole.SUPER_ADMIN

  return navs
    .filter((nav) => {
      if (!nav.roles || nav.roles.length === 0) {
        return role === AdminRole.SUPER_ADMIN
      }
      return nav.roles.includes(role as never)
    })
    .map((nav) => ({
      ...nav,
      sub: nav.sub?.filter((sub) => {
        if (!sub.roles || sub.roles.length === 0) {
          return role === AdminRole.SUPER_ADMIN
        }
        return sub.roles.includes(role as never)
      }),
    }))
    .filter((nav) => !nav.sub || nav.sub.length > 0)
}
